import React from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TerminalSection from './components/TerminalSection';
import AboutSection from './components/AboutSection';
import SkillsSection from './components/SkillsSection';
import CertificationsSection from './components/CertificationsSection';
import PortfolioSection from './components/PortfolioSection';
import ShortFilmBanner from './components/ShortFilmBanner';
import BlogSection from './components/BlogSection';
import ContactSection from './components/ContactSection';

function App() {
  return (
    <div className="min-h-screen bg-[#06080d] text-[#f1f5f9] relative">
      {/* Background grid */}
      <div className="cyber-grid" />

      {/* Content */}
      <Header />
      <main>
        <HeroSection />
        <TerminalSection />
        <AboutSection />
        <SkillsSection />
        <CertificationsSection />
        <PortfolioSection />
        <ShortFilmBanner />
        <BlogSection />
        <ContactSection />
      </main>
    </div>
  );
}

export default App;
